import React, { useEffect, useState } from "react";
import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import api from "../../services/api";
import DataTable from "react-data-table-component";

const OperadorDepScreen = () => {
  const [loading, setLoading] = useState(true);
  const [operadorDep, setOperadorDep] = useState([]);

  const handlerdata = (dt) => {
    return new Date(dt).toLocaleDateString("pt-BR");
  };

  const columns = [
    {
      width: "30%",
      name: "REALIZADO POR",
      button: true,
      cell: (row) => (
        <div className="text-center">
          {row.operador_id?.nome}
          <br />
          {row.operador_id?.email}
        </div>
      ),
    },
    {
      name: "LIBERADO EM",
      selector: (row) => handlerdata(row.createdAt),
      sortable: true,
    },
    {
      name: "CPF DEPENDENTE",
      selector: (row) => row.cpf,
      sortable: true,
    },
    {
      name: "MATRÍCULA",
      selector: (row) => row.matriculaDep,
      sortable: true,
    },
    {
      width: "10%",
      name: "STATUS",
      button: true,
      cell: (row) => (
        <div className="text-center">
          {row.status === 1 ? (
            <span className="badge badge-primary">LIBERADO</span>
          ) : row.status === 2 ? (
            <span className="badge badge-danger">NEGADO</span>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      width: "20%",
      name: "MOTIVO",
      selector: (row) => row.motivo || "-",
      sortable: true,
    },
  ];

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };


  useEffect(() => {
    const pesquisa = async () => {
      try {
        const config = { headers: { "Content-Type": "application/json" } };
        const resp = await api.get("/api/operador-dependente", config);
        setOperadorDep(resp.data);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        toast.error("Erro ao carregar os dados.");
      } finally {
        setLoading(false);
      }
    };

    if (loading) {
      pesquisa();
    }
  }, [loading]);

  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <DataTable
                  title="Gerenciamento dos Dependentes Realizados pelo CRC"
                  columns={columns}
                  data={operadorDep}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  noDataComponent="Nenhum registro encontrado."
                />
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default OperadorDepScreen;
